import { render, staticRenderFns } from "./Voiceover.vue?vue&type=template&id=e25cbe24&scoped=true&"
import script from "./Voiceover.vue?vue&type=script&lang=ts&"
export * from "./Voiceover.vue?vue&type=script&lang=ts&"
import style0 from "./Voiceover.vue?vue&type=style&index=0&id=e25cbe24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25cbe24",
  null
  
)

export default component.exports